import styled from 'styled-components';

export const ModalContainer = styled.div`
  padding-bottom: 10px;
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 20px;
  }
  .ant-radio-button-wrapper {
    margin-right: 10px;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background: #1890ff;
    border-color: #1890ff;
  }
  .info {
    background-color: #fffdf5;
    border: solid 2px #fff1b8;
    padding: 1rem 0.5rem;
    display: block;
    margin-top: 3rem;
  }
  p {
    font-size: 14px;
    color: #8c8c8c;
  }
  .searchBtn {
    margin-left: 10px;
  }
  .box-date {
    background-color: #fafafa;
    border: solid 2px #d9d9d9;
    padding: 1rem 0.5rem;
  }
`;
export const Line = styled.div`
  position: static;
  width: 100%;
  height: 0px;
  left: 24px;
  top: 523px;
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  margin-top: 15px;
`;
